export enum FormStatus {
  UNKNOWN,
  UNFILLED,
  FILLED,
  DOING_UPDATE,
}

export const LONG_NAME_LENGTH = 30;

export const APPLICATION_NAME = 'VerifiMe Customer Portal';

export const OTP_VALIDATION_WINDOW = parseInt(
  process.env.NEXT_PUBLIC_TOTP_VALIDATION_WINDOW || '3', // Default to 3 minutes if not set in environment variables
);
